module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/postcode.js
// module id = 1398
// module chunks = 0